import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { tasaciones, cucicbaReferencial } from '../data/mock';

const tabs = ['Argenprop', 'Properati', 'CUCICBA', 'NTSYS'];

const properatiData = [
  { id: 10, fuente: 'Properati', direccion: 'Rojas 145, P2', precio_usd: 122000, sup_cubierta: 64, precio_m2_usd: 1906, ambientes: 2, dias_publicado: 21 },
  { id: 11, fuente: 'Properati', direccion: 'Av. Rivadavia 4350', precio_usd: 138000, sup_cubierta: 72, precio_m2_usd: 1916, ambientes: 3, dias_publicado: 30 },
  { id: 12, fuente: 'Properati', direccion: 'Beauchef 560, P1', precio_usd: 115000, sup_cubierta: 60, precio_m2_usd: 1916, ambientes: 2, dias_publicado: 45 },
];

const cucicbaData = [
  { zona: 'Caballito', tipo: 'Departamento 1-2 amb', min: 1820, max: 2050 },
  { zona: 'Caballito', tipo: 'Departamento 3+ amb', min: 1900, max: 2150 },
  { zona: 'Caballito', tipo: 'PH', min: 1750, max: 2000 },
];

export default function Comparables() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const tasacion = tasaciones.find(t => t.id === parseInt(id)) || tasaciones[0];
  const argenpropData = tasacion.comparables.filter(c => c.fuente === 'Argenprop');

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="topbar-left">
          <span className="topbar-back" onClick={() => navigate(-1)}>←</span>
          <div>
            <div className="topbar-title">Comparables</div>
            <div className="topbar-sub">{tasacion.direccion} · {tasacion.sup_cubierta} m²</div>
          </div>
        </div>
        <span className="topbar-action">🔄</span>
      </div>

      <div className="page-body">
        <div className="cucicba-banner">
          <div className="cucicba-label">📊 Valor referencial CUCICBA · {cucicbaReferencial.zona}</div>
          <div className="cucicba-val">USD {cucicbaReferencial.valor_min.toLocaleString()} – {cucicbaReferencial.valor_max.toLocaleString()} / m²</div>
        </div>

        <div className="tabs">
          {tabs.map((t, i) => (
            <div key={t} className={`tab${activeTab === i ? ' active' : ''}`} onClick={() => setActiveTab(i)}>{t}</div>
          ))}
        </div>

        {activeTab === 0 && (
          <>
            {argenpropData.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '32px 0', color: 'var(--text-muted)', fontSize: 13 }}>
                🔍 No hay comparables cargados
              </div>
            ) : argenpropData.map(c => (
              <div key={c.id} className="comp-card">
                <div className="comp-top">
                  <div className="comp-addr">{c.direccion}</div>
                  <div className="comp-price">USD {c.precio_usd.toLocaleString()}</div>
                </div>
                <div className="comp-meta">
                  {c.sup_cubierta} m² · {c.ambientes} amb · hace {c.dias_publicado} días
                  <span className="source-dot">Argenprop</span>
                </div>
                <div style={{ marginTop: 6, fontSize: 12, color: 'var(--teal)', fontWeight: 600 }}>
                  USD {c.precio_m2_usd.toLocaleString()} / m²
                </div>
              </div>
            ))}
          </>
        )}

        {activeTab === 1 && properatiData.map(c => (
          <div key={c.id} className="comp-card">
            <div className="comp-top">
              <div className="comp-addr">{c.direccion}</div>
              <div className="comp-price">USD {c.precio_usd.toLocaleString()}</div>
            </div>
            <div className="comp-meta">
              {c.sup_cubierta} m² · {c.ambientes} amb · hace {c.dias_publicado} días
              <span className="source-dot" style={{ background: 'var(--success-bg)', color: 'var(--success-text)' }}>Properati</span>
            </div>
            <div style={{ marginTop: 6, fontSize: 12, color: 'var(--teal)', fontWeight: 600 }}>
              USD {c.precio_m2_usd.toLocaleString()} / m²
            </div>
          </div>
        ))}

        {activeTab === 2 && (
          <div className="card">
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Valores referenciales CUCICBA — Junio 2026
            </div>
            {cucicbaData.map((r, i) => (
              <div key={i} className="result-row">
                <span className="result-row-label">{r.tipo}</span>
                <span className="result-row-val">USD {r.min.toLocaleString()}–{r.max.toLocaleString()}/m²</span>
              </div>
            ))}
            <div style={{ marginTop: 12, fontSize: 11, color: 'var(--text-light)' }}>
              Fuente: Colegio Único de Corredores Inmobiliarios de CABA
            </div>
          </div>
        )}

        {activeTab === 3 && (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--text-muted)' }}>
            <div style={{ fontSize: 32, marginBottom: 12 }}>🚧</div>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 6 }}>Base NTSYS en construcción</div>
            <div style={{ fontSize: 12 }}>Próximamente: comparables de operaciones cerradas registradas en la plataforma</div>
          </div>
        )}

        <div style={{ marginTop: 16 }}>
          <button className="btn-primary" onClick={() => navigate(`/resultado/${tasacion.id}`)}>
            📊 Calcular tasación
          </button>
        </div>
      </div>
    </div>
  );
}
